import { LoadingButton } from "@mui/lab"
import { Switch } from "@mui/material"
import { t } from "i18next"
import React, { useState } from "react"
import { GroupModel } from "../../models/organisation/GroupModel"
import { colorLightGreen, colorRed } from "../../rsc/colors/colors"
import { updateGroupPricePrivacy } from "../../api"
import { client } from "../.."
import { showErrorMessage } from "../../helper/helper"

type GroupProps = {
    group: GroupModel
}

function GroupRow({ group }: GroupProps) {

    const [checked, setChecked] = useState(group.isPuclicVisible)

    function onChange(value) {
        group.isPuclicVisible = value
        setChecked(value)
    }

    return (
        <div style={{ display: "flex", gap: "30px", alignItems: "center" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <Switch checked={checked} onChange={e => { onChange(e.target.checked) }} />
            </div>
            <div>
                {group.name}
            </div>
            <p style={{ fontWeight: 600, color: checked ? colorLightGreen : colorRed }}>{checked ? t('public') : t('secret')}</p>
        </div>
    )
}

type Props = {
    orgId: string
    canSeeNam: boolean
    groups: GroupModel[]
}

export function OrgProfileGroup({ orgId, groups, canSeeNam }: Props) {

    const [saving, setSaving] = useState(false)
    const [checked, setChecked] = useState(canSeeNam)

    function updateGroups() {
        setSaving(true)
        const input = groups.map(g => {
            return {
                group_id: g.id,
                is_public: g.isPuclicVisible
            }
        })
        client.mutate({
            mutation: updateGroupPricePrivacy,
            variables: {
                input: input,
                orgId: parseInt(orgId),
                namPrivacy: checked
            }
        }).then((data) => {
        }).catch(e => {
            showErrorMessage(e)
        }).finally(() => {
            setSaving(false)
        })
    }

    return (
        <div>
            <div style={{ display: "flex", flexDirection: "column", width: "fit-content", gap: "20px" }}>
                <div>
                    <div style={{ display: "flex", gap:'10px' }}>
                        <p className="font-xlnormal underline">{t('setting_show_nam_price')}</p>
                        <p style={{ fontWeight: 600, color: checked ? colorLightGreen : colorRed, alignSelf:"center" }}>{checked ? t('public') : t('secret')}</p>
                    </div>
                    <div style={{ display: "flex", gap: "30px", alignItems: "center" }}>
                        <Switch checked={checked} onChange={e => { setChecked(e.target.checked) }} />
                    </div>
                </div>
                <div>
                    <p className="font-xlnormal underline">{t('setting_show_group_price')}</p>
                    <div style={{ borderCollapse: "collapse", marginTop: "10px" }}>
                        {
                            groups.map(g => {
                                return <GroupRow key={g.id} group={g} />
                            })
                        }
                    </div>
                </div>
            </div>
            <div className="flex justify-end mt-[30px]" >
                <LoadingButton onClick={updateGroups} variant="contained" loading={saving}>{t('save')}</LoadingButton>
            </div>
        </div>
    )
}